import { useTranslation } from 'react-i18next';
import type { LucideIcon } from 'lucide-react';
import { StateShell } from '@/components/common/StateShell';

/**
 * Every route renders one of these. It names the screen and says what will live there, because an
 * honest empty state is information and a mocked-up table is a lie with a deadline. Compact (UX audit
 * S11), and its copy speaks to the dispatcher, not to the developers.
 */
export function EmptyState({ id, icon }: { id: string; icon: LucideIcon }) {
  const { t } = useTranslation();

  return (
    <StateShell icon={icon} title={t(`pages.${id}.title`)} compact>
      <p className="text-sm text-ink-secondary">{t(`pages.${id}.blurb`)}</p>
      <span className="rounded-full bg-sunken px-3 py-1 text-sm font-medium text-ink-muted">
        {t('empty.notBuilt')}
      </span>
      <p className="text-sm text-ink-muted">{t('empty.explain')}</p>
    </StateShell>
  );
}
